export const titleCase = (value: string) => {
    return value.split(" ")
        .map((sub: any) => sub.slice(0, 1).toUpperCase() + sub.slice(1))
        .join(" ");
};
